const closeIcon = `
  <svg class="icon icon-close" aria-hidden="true"><use xlink:href="#icon-close"></use></svg>
`;

export const getInputForKeyAndValue = (key, val) => {
  const input = document.querySelector(`[name="${key}"]`);

  if (!input) {
    return null;
  }

  // In case it's a check type input the're multiple input elements
  if (input.type === 'checkbox' || input.type === 'radio') {
    return document.querySelector(`[name="${key}"][value="${val}"]`);
  }

  return input;
};

export const getLabelTextForInput = (key, val) => {
  const input = getInputForKeyAndValue(key, val);

  if (!input) {
    return null;
  }

  const label = input.getAttribute('data-label');

  if (!label) {
    return null;
  }

  if (input.tagName === 'SELECT') {
    const selectedOptionText = input.selectedOptions[0].text;
    return label.replace('[value]', selectedOptionText);
  }

  return label.replace('[value]', val);
};

export const renderSelectedFilter = (filter) => `
  <button
    type="button"
    class="selected-filters__filter btn--reset"
    data-name="${filter.key}"
    data-value="${filter.value}"
    data-action="click->filters#onDeleteFilter"
    data-target="filters.selectedDeleteButtons"
  >
    ${filter.label} ${closeIcon}
  </button>
`;

export const getDefaultForInput = (input) => input.getAttribute('data-default');

export const deleteFilter = (key, value) => {
  const input = getInputForKeyAndValue(key, value);
  const defaultValue = getDefaultForInput(input);

  if (defaultValue) {
    input.value = defaultValue;
  } else if (input.type === 'checkbox' || input.type === 'radio') {
    input.checked = false;
  } else {
    input.value = '';
  }
};

export const deleteFilterForButton = (button) => {
  deleteFilter(button.getAttribute('data-name'), button.getAttribute('data-value'));
};
